import { Stack } from "@mui/material";
import { CheckGreen } from "src/assets";
import Text from "src/components/Displays/Text";
import { useTranslation } from "react-i18next";
import { useSessionStorage } from "src/hooks/useSessionStorage";
import PrimaryButton from "src/components/Shared/PrimaryButton";
import { MicroFrontendDetails, SESSION_KEYS } from "src/consts/session";

const ConnectingSuccess = () => {
  const { t } = useTranslation();

  const [getSessionStorageItem] = useSessionStorage<MicroFrontendDetails>(
    SESSION_KEYS.MICRO_FRONTEND_DETAILS,
  );

  const handleSubmit = () => {
    const sessionData = getSessionStorageItem();
    if (sessionData) {
      window.location.href = sessionData?.callbackUrlSuccess;
    }
  };

  return (
    <>
      <Stack gap={10}>
        <Stack direction={"row"} alignItems={"center"} gap={1}>
          <Text
            text={t("page.wallboxConnectingSuccess.pageTitle")}
            sx={(theme) => ({
              fontSize: "32px",
              lineHeight: "35px",
              fontFamily: "isonType",
              color: theme.palette.mainFont.primary,
            })}
          />
        </Stack>

        <Stack alignItems={"start"}>
          <CheckGreen />
        </Stack>

        <Text
          text={t("page.wallboxConnectingSuccess.pageSubTitle1")}
          sx={(theme) => ({
            fontSize: "14px",
            lineHeight: "24px",
            color: theme.palette.mainFont.primary,
          })}
        />

        <Text
          text={t("page.wallboxConnectingSuccess.pageSubTitle2")}
          sx={(theme) => ({
            fontSize: "14px",
            lineHeight: "24px",
            color: theme.palette.mainFont.primary,
          })}
        />

        <PrimaryButton
          fullWidth
          onClick={handleSubmit}
          text={t("page.wallboxConnectingSuccess.nextButton")}
          sx={(theme) => ({
            fontSize: "14px",
            lineHeight: "20px",
            color: theme.palette.mainFont.primary,
          })}
        />
      </Stack>
    </>
  );
};

export default ConnectingSuccess;
